import script from "./KiwishHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./KiwishHeader.vue?vue&type=script&setup=true&lang=js"

import "./KiwishHeader.vue?vue&type=style&index=0&id=22507901&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22507901"]])

export default __exports__